import React from "react";
import myLogo from "../img/my-logo.png";
import { APP_NAME, APP_URL } from "../utils/constants";

const Footer = () => {
	return (
		<div className="w-full h-40 bg-orange-600 text-white flex sm:flex-row flex-col items-center justify-around sm:justify-between">
			<div className="ps-4 flex items-center gap-4 sm:flex-row flex-col">
				<div className="text-lg flex items-center gap-4">
					<div>
						<img
							className="h-12 border border-black rounded-full contrast-150"
							src={myLogo}
							alt="myLogo"
						></img>
					</div>
					<h1 className="text-xl font-semibold">{APP_NAME}</h1>
				</div>
				<span className="hidden sm:inline text-2xl opacity-70">|</span>
				<div>
					<p>Copyright © 2024 {APP_URL}</p>
				</div>
			</div>
			<div className="flex gap-5 m-3 text-xl">
				<i className="cursor-pointer opacity-80 hover:text-black fa-brands fa-github"></i>
				<i className="cursor-pointer opacity-80 hover:text-black fa-brands fa-linkedin-in"></i>
				<i className="cursor-pointer opacity-80 hover:text-black fa-brands fa-instagram"></i>
				<i className="cursor-pointer opacity-80 hover:text-black fa-brands fa-twitter"></i>
			</div>
		</div>
	);
};

export default Footer;
